<template>
    <div class="animated fadeIn">
        <Request
                ref="request"
                root="/binder-template/structure"
                method="GET"
                :onRequestSuccess="requestSuccess"
                :onRequestError="requestError">
            <slot slot="body">
                <div>
                    <FormBuilder ref="formBuilder" v-if="Core.Validation.isId(dataId)" :formBuilderFieldOptions="{root: { get: '/binder-template/structure-field' } }" v-model="dataRows" :listBuilder="true" :titleBuilder="true" :searchBuilder="true"></FormBuilder>
                </div>
                <div>
                    <hr/>
                    <b-button type="button" @click="onSaveStructureClick" variant="success">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
                </div>
            </slot>
        </Request>
    </div>
</template>

<script>
    import Request from '../../components/Request'
    import FormBuilder from '../../components/FormBuilder'
    export default {
        name: 'BinderTemplateStructure',
        components: {
            Request,
            FormBuilder
        },
        props: {
            value: {
                type: String | Number,
                default: ''
            }
        },
        watch: {
            value(val) {
                this.dataId = val
            },
            dataId(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataId = this.value
            this.$refs.request.clearArgs()
            this.$refs.request.setMethod('GET')
            this.$refs.request.addArg('binderTemplateId', this.dataId)
            this.$refs.request.request()
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataId: '',
                dataRows: []
            }
        },
        methods: {
            requestSuccess(data) {
                if (data.rows !== undefined) {
                    this.dataRows = data.rows
                }
                if (data.list !== undefined) {
                    this.$refs.formBuilder.list = data.list
                }
                if (data.title !== undefined) {
                    this.$refs.formBuilder.title = data.title
                }
                if (data.search !== undefined) {
                    this.$refs.formBuilder.search = data.search
                }
            },
            requestError(data) {
            },
            onSaveStructureClick() {
                this.$refs.request.clearArgs()
                this.$refs.request.setMethod('PUT')
                this.$refs.request.addArg('binderTemplateId', this.dataId)
                this.$refs.request.addArg('list', JSON.stringify(this.$refs.formBuilder.list))
                this.$refs.request.addArg('search', JSON.stringify(this.$refs.formBuilder.search))
                this.$refs.request.addArg('title', JSON.stringify(this.$refs.formBuilder.title))
                this.$refs.request.addArg('rows', JSON.stringify(this.dataRows))
                this.$refs.request.request()
            }
        }
    }
</script>
